import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/scrollbar';
import './text-image-slider.scss';

class TextImageSlider {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-text-image-slider',
            sliderAttr: 'main',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$textImage = $element;
        this.$textImageContainer = this.$textImage.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$textImageSlides = this.$textImage.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.textImageSlider = null;

        if (this.$textImageContainer && this.$textImageSlides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.initSlider();
    }

    initSlider () {
        const prevBTN = this.$textImage.querySelector('.swiper-button-prev');
        const nextBTN = this.$textImage.querySelector('.swiper-button-next');
        const scrollBar = this.$textImage.querySelector('.swiper-scrollbar');
        this.textImageSlider = new Swiper(this.$textImageContainer, {
            modules: [Navigation, Scrollbar, A11y],
            speed: 400,
            spaceBetween: 30,
            effect: 'fade',
            slidesPerView: 1,
            scrollbar: {
                el: scrollBar,
                draggable: true,
                dragSize: 50
            },
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide'
            },
            navigation: {
                prevEl: prevBTN,
                nextEl: nextBTN,
                addIcons: false,
            }
        });
    }

    destroySlider () {
        if (this.textImageSlider !== null) {
            this.textImageSlider.destroy(true, true);
            this.textImageSlider = null;
        }
    }
}

export { TextImageSlider };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$TextImageSlider = $context.querySelectorAll('[data-text-image-slider="root"]');

        for (let i = 0; i < $$TextImageSlider.length; i++) {
            const $TextImageSlider = $$TextImageSlider[i];
            const TextImageSliderAPI = new TextImageSlider($TextImageSlider);
            $TextImageSlider.API = TextImageSliderAPI;
        }
    }
});
